export type { HttpClient } from './types';

export { createProductService } from './productService';
export { createCategoryService } from './categoryService';
export { createOrderService } from './orderService';
export { createAuthService } from './authService';
export { createPaymentService } from './paymentService';
export { createUserClientService } from './userClientService';
export { createShippingService } from './shippingService';
export { createBannerService } from './bannerService';
export { createAnalyticsService } from './analyticsService';
export { createUserAddressService } from './userAddressService';
export { createCouponService } from './coupon.service';
export { createTiendaInfoService } from './tiendaInfoService';
export type { TiendaInfoDTO } from './tiendaInfoService';

import { HttpClient } from './types';
import { createProductService } from './productService';
import { createCategoryService } from './categoryService';
import { createOrderService } from './orderService';
import { createAuthService } from './authService';
import { createPaymentService } from './paymentService';
import { createUserClientService } from './userClientService';
import { createShippingService } from './shippingService';
import { createBannerService } from './bannerService';
import { createAnalyticsService } from './analyticsService';
import { createUserAddressService } from './userAddressService';
import { createCouponService } from './coupon.service';
import { createTiendaInfoService } from './tiendaInfoService';

export const createAllServices = (httpClient: HttpClient) => ({
  products: createProductService(httpClient),
  categories: createCategoryService(httpClient),
  orders: createOrderService(httpClient),
  auth: createAuthService(httpClient),
  payments: createPaymentService(httpClient),
  userClients: createUserClientService(httpClient),
  shippings: createShippingService(httpClient),
  banners: createBannerService(httpClient),
  analytics: createAnalyticsService(httpClient),
  userAddresses: createUserAddressService(httpClient),
  coupons: createCouponService(httpClient),
  tiendaInfo: createTiendaInfoService(httpClient),
});


